import AuthWrapper from '@/features/auth/components/AuthWrapper';
import { locationHelperBuilder } from '@/features/auth/utils';

const locationHelper = locationHelperBuilder({});

export const protectRoute = AuthWrapper({
  redirectPath: () => locationHelper.createRedirectLoc('/login'),
  // If selector is true, wrapper will not redirect
  shouldComponentRender: (authSessionState: { isAuthenticated?: boolean }) => Boolean(authSessionState?.isAuthenticated),
  isLoading: (authSessionState: { isLoading?: boolean }) => Boolean(authSessionState?.isLoading),
  AuthenticatingComponent: () => <h1>Loading...</h1>,
});

/**
 * Higher-order component that protects login pages from authenticated users.
 *
 * When a user is already authenticated, this wrapper redirects them away from
 * login-related pages to prevent unnecessary login attempts.
 *
 * @remarks
 * - Redirects authenticated users to either a query parameter route or the dashboard
 * - Shows a loading component while authentication state is being determined
 * - Only renders the wrapped component when user is not authenticated and not loading
 *
 * @example
 * ```tsx
 * const ProtectedLogin = protectLogin(LoginComponent);
 * ```
 */
export const protectLogin = AuthWrapper({
  // This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
  redirectPath: () =>
    localStorage.getItem('isNewUser') === 'true' ? '/dashboard/spaces' : locationHelper.getRedirectQueryParam() || '/dashboard',
  shouldComponentRender: (authSessionState: { isAuthenticated?: boolean; isLoading?: boolean }) =>
    !authSessionState?.isAuthenticated && !authSessionState?.isLoading,
  isLoading: (authSessionState: { isLoading?: boolean }) => Boolean(authSessionState?.isLoading),
  AuthenticatingComponent: () => <h1>Loading...</h1>,
});
